import * as actions from "./actions";

export const onSelectedProductChange = (payload) => ({
  type: actions.ON_SELECTED_PRODUCT_CHANGE,
  payload: { ...payload }
});

export const onSelectedDateRangeChange = (payload) => ({
  type: actions.ON_SELECTED_DATE_RANGE_CHANGE,
  payload: { ...payload }
});

export const onSelectedZoneChange = (payload) => ({
  type: actions.ON_SELECTED_ZONE_CHANGE,
  payload: { ...payload }
});



// WEBPACK FOOTER //
// ./src/store/analytics/chart-filters/action-creators.js